import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
};

const ShoppingBasketIcon = ({ color = '#0D84FE', size = 22, ...props }) => (
  <svg
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 22 24"
    {...props}
  >
    <path
      d="M2.404 24h16.792a1.199 1.199 0 0 0 1.2-1.118l1.199-16.76a1.073 1.073 0 0 0-.32-.878 1.12 1.12 0 0 0-.88-.399h-4.118A5.513 5.513 0 0 0 10.8 0a5.513 5.513 0 0 0-5.477 4.845H1.205a1.12 1.12 0 0 0-.88.4c-.235.228-.352.55-.32.877l1.2 16.76c.042.63.567 1.12 1.2 1.118zM10.8 2.45a3.12 3.12 0 0 1 3.04 2.395H7.76a3.12 3.12 0 0 1 3.04-2.394H10.8zM5.282 7.24v4.788h2.4V7.24h6.237v4.79h2.399v-4.79h2.798l-1.04 14.367H3.524L2.484 7.239h2.798z"
      fill={color}
      fillRule="evenodd"
    />
  </svg>
);

ShoppingBasketIcon.propTypes = propTypes;

export default ShoppingBasketIcon;
